import { render, staticRenderFns } from "./ProductInfinite.vue?vue&type=template&id=b1ea3aec"
import script from "./ProductInfinite.vue?vue&type=script&lang=js"
export * from "./ProductInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports